const EVENT_NAME = {
  //data and privacy event_name/s
  DATA_PRIVACY_LANDING_PAGE_SCREEN_SHOWN: 'data_privacy_landing_page_loaded',
  PRIVACY_SECTION_PERMISSIONS_GIVEN_LINK_CLICKED:
    'permissions_given_link_clicked',
  PRIVACY_SECTION_MANAGE_COOKIES_LINK_CLICKED: 'manage_cookies_link_clicked',
  PRIVACY_SECTION_PP_SHOPPING_LINK_CLICKED: 'pp_shopping_link_clicked',
  PRIVACY_SECTION_INTERST_MARKETING_LINK_CLICKED:
    'interest_based_marketing_link_clicked',
  PRIVACY_SECTION_SEARCH_PRIVACY_LINK_CLICKED: 'search_privacy_link_clicked',
  PRIVACY_SECTION_BLOCKED_CONTACTS_LINK_CLICKED:
    'blocked_contacts_link_clicked',
  PRIVACY_SECTION_DOWNLOAD_DATA_LINK_CLICKED: 'download_data_link_clicked',
  PRIVACY_SECTION_CORRECT_DATA_LINK_CLICKED: 'correct_your_data_link_clicked',
  PRIVACY_SECTION_DELETE_DATA_LINK_CLICKED: ' delete_your_data_link_clicked',
  PRIVACY_SECTION_MANAGE_FACE_SCAN_LINK_CLICKED:
    'manage_face_scan_link_clicked',
  PRIVACY_SECTION_DAR_HISTORY_LINK_CLICKED: 'dar_history_link_clicked',

  //shopping-settings event_name/s
  SHOPPING_SETTING_PAGE: 'shopping_setting_page_loaded',
  SHOPPING_SETTING_SHOPPING_OPTION_TURN_ON: 'shopping_option_turned_on',
  SHOPPING_SETTING_SHOPPING_OPTION_TURN_OFF: 'shopping_option_turned_off',
  SHOPPING_SETTING_BACK_NAVIGATION_CLICKED:
    'shopping_setting_back_navigation_clicked',
  SHOPPING_SETTING_LEARN_HOW_IT_WORKS_LINK_CLICKED:
    'learn_how_it_works_link_clicked',
  SHOPPING_SETTING_MANAGE_EMAIL_PREFERENCES_CARD_CLICKED:
    'manage_email_preferences_card_clicked',

  //search-privacy-modal
}

export { EVENT_NAME }
